import { productionOrderTypeMap } from '@/modules/productionModule/constants/productionOrder'

const assignmentStatusMap: Record<string, string> = {
	pending: 'Oczekujące',
	assigned: 'Przypisane',
	failed: 'Błąd',
	manual: 'Ręczne',
}

export const DemandOrder = (json: IDemandOrder): IDemandOrderModel => {
	const {
		external_id,
		order_type,
		group_delivery_id,
		region_identifier,
		region_forwarder,
		order_status,
		assignment_status,
		assigned_facility_id,
		assigned_facility_name,
		assigned_at,
		...rest
	} = json

	return {
		...rest,
		externalId: external_id,
		orderType: order_type,
		orderTypeLabel: productionOrderTypeMap[order_type] ?? order_type,
		date: new Date(json.date),
		groupDeliveryId: group_delivery_id,
		regionIdentifier: region_identifier,
		regionForwarder: region_forwarder,
		orderStatus: order_status,
		assignmentStatus: assignment_status,
		assignmentStatusLabel: assignmentStatusMap[assignment_status] ?? assignment_status,
		assignedFacilityId: assigned_facility_id,
		assignedFacilityName: assigned_facility_name,
		assignedAt: assigned_at ? new Date(assigned_at) : null,
	}
}
